import { SessionHelper } from "utils/helpers";
import { store } from "store";
import { ONBOARDING_SESSION_KEY_PREFIX } from "serviceHooks/useAPIClientHelper";
import { loginSuccess } from "store/actions/authActions";
import { Person } from "models/stateTypes/authState";
import { ReduxConstants } from "utils/constants";

const AuthHelper = {
  /**
   * @deprecated This function is deprecated. Use useSelector for Redux state access.
   *
   * Migration guide:
   * 1. Create a custom hook (e.g., useAuthHelper)
   * 2. Use useSelector to access Redux state instead of store.getState() and use useDispatch to dispatch actions
   * 3. Move this logic into the custom hook
   * 4. Use the hook in components instead of calling this function
   *
   * @see useSelector - React Redux hook for accessing state
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * const isAuth = AuthHelper.authenticate();
   *
   * @example
   * // New way (recommended):
   * function useAuthHelper() {
   *   const isAuthorized = useSelector((state: AppState) => state.auth.isAuthorized);
   *
   *   const authenticate = () => {
   *     if (isAuthorized) return true;
   *     // Move existing logic here using isAuthorized
   *   };
   *
   *   return { authenticate };
   * }
   *
   * // In component:
   * const { authenticate } = useAuthHelper();
   * const isAuth = authenticate();
   */
  authenticate: () => {
    if (store.getState().auth.isAuthorized) return true;

    const userSession = SessionHelper.getSessionItem<Person>("user_session");
    if (userSession && userSession.key) {
      store.dispatch(loginSuccess(userSession, true));
      return true;
    }

    return false;
  },

  /**
   * @deprecated This function is deprecated. Use useDispatch to dispatch actions
   *
   * @see useDispatch - React Redux hook for dispatching actions
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * AuthHelper.logout();
   *
   * @example
   * // New way (recommended):
   * import { useDispatch } from "react-redux";
   *
   * const MyComponent = () => {
   *   const dispatch = useDispatch();
   *   dispatch(logout());
   * };
   */

  logout: () => {
    // The onboarding credential belongs to an invite, not to this session, so it outlives it.
    SessionHelper.clearSession([], [ONBOARDING_SESSION_KEY_PREFIX]);
    store.dispatch({
      type: ReduxConstants.AuthActions.LOGOUT,
    });
  },

  /**
   * @deprecated This function is deprecated. Use useSelector for Redux state access.
   *
   * @see useSelector - React Redux hook for accessing state
   * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
   *
   * @example
   * // Old way (deprecated):
   * const isSelected = AuthHelper.isSelectedCompany(companyId);
   *
   * @example
   * // New way (recommended):
   * const selectedCompanyId = useSelector((state: AppState) => state.auth.selectedCompanyId);
   */
  isSelectedCompany: (companyId: number) => {
    return companyId === store.getState().auth.selectedCompanyId;
  },
};

export default AuthHelper;
